import React from 'react';
import { 
  HiOutlineLightningBolt, 
  HiOutlineChartBar, 
  HiOutlineLink,
  HiOutlineUserGroup,
  HiOutlineExclamationCircle,
  HiOutlineTrendingUp
} from 'react-icons/hi';
import type { IconType } from 'react-icons';
import './Features.css';

const IconWrapper: React.FC<{ Icon: IconType; color: string }> = ({ Icon, color }) => {
  const IconComponent = Icon as any;
  return <IconComponent style={{ color }} />;
};

interface Feature {
  Icon: IconType;
  title: string;
  description: string;
  color: string;
}

const features: Feature[] = [
  {
    Icon: HiOutlineChartBar,
    title: 'Métricas de Engenharia',
    description: 'Cycle time, lead time, throughput e análise completa do desempenho do seu time de desenvolvimento.',
    color: 'var(--chart-1)'
  },
  {
    Icon: HiOutlineUserGroup,
    title: 'Opindex - Performance de Contribuidores',
    description: 'Índice único que combina volume, qualidade, complexidade e engajamento para medir e desenvolver seu time.',
    color: 'var(--chart-1)'
  },
  {
    Icon: HiOutlineExclamationCircle,
    title: 'Gestão de Incidentes',
    description: 'Monitore incidentes, MTTR, MTBF e melhore a confiabilidade dos seus sistemas com gestão completa.',
    color: 'var(--chart-5)'
  },
  {
    Icon: HiOutlineLightningBolt,
    title: 'Métricas em Tempo Real',
    description: 'Acompanhe PRs, reviews e deploys conforme acontecem, com atualizações instantâneas via webhooks.',
    color: 'var(--chart-2)'
  },
  {
    Icon: HiOutlineTrendingUp,
    title: 'Análise de Performance',
    description: 'Dashboards interativos com gráficos, filtros por período e repositório, e insights acionáveis.',
    color: 'var(--chart-3)'
  },
  {
    Icon: HiOutlineLink,
    title: 'Integração GitHub',
    description: 'Conecte seus repositórios em minutos com autenticação OAuth segura e configuração simplificada.',
    color: 'var(--chart-4)'
  }
];

export const Features: React.FC = () => {
  return (
    <section id="features" className="features-section">
      <div className="features-container">
        <div className="features-header">
          <h2 className="features-title">Tudo que você precisa para medir o que importa</h2>
          <p className="features-subtitle">
            Ferramentas poderosas para transformar dados do GitHub em insights acionáveis
          </p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="feature-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="feature-icon">
                <IconWrapper Icon={feature.Icon} color={feature.color} />
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

